import { useState } from "react";
import { FaInstagram } from "react-icons/fa";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-top">
        <img src="/RevivedLogo.webp" alt="Logo" className="site-logo" />

        {/* Hamburger button */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>

        {/* Navigation */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <a href="#barbers" className="nav-link">Barbers</a>
          <a href="#hairstylists" className="nav-link">Hairstylists</a>
          <a href="#booking" className="nav-link">Directions</a>

          {/* Instagram icon inside nav */}
          <a
  href="https://instagram.com/revivedhairco?igsh=MmFleDl1NGh2Y3Ft"
  target="_blank"
  rel="noopener noreferrer"
  className="nav-insta"
>
  <FaInstagram size={34} />
</a>
        </nav>
      </div>
    </header>
  );
}